import { Mg2Action } from "./Mg2Action";
import { Auth0ClientInstance } from "../plugins/auth/Auth0ClientInstance";
export class LoginAction extends Mg2Action {
    constructor() {
        super(...arguments);
        this.actionName = "login";
    }
    run() {
        Auth0ClientInstance.login();
    }
}
